import { DateTime } from 'luxon';

export function toRelative(text: string): string {
  const date = DateTime.fromISO(text);
  return Math.abs(date.diffNow().as('seconds')) <= 5
    ? 'just now'
    : date.toRelative() || '';
}
